import {UPDATE_OFFERS_START} from "../../types";

export const update_offers = (payload) => ({
    type: UPDATE_OFFERS_START,
    payload,
});
